/**
 * El texto legible de un error del cliente HTTP.
 *
 * `message` llega como cadena o como arreglo: NestJS manda un renglon por cada
 * regla de validacion incumplida. Pintado tal cual, el arreglo sale como
 * «a,b,c», y un error sin `message` no sale en absoluto, que es peor: la
 * pantalla se queda callada y el usuario solo ve que el boton no hizo nada.
 *
 * Hay ocho pantallas que arman esto a mano; las nuevas usan este.
 */
export const mensajeDeError = (
  error: unknown,
  respaldo = 'Ocurrió un error. Intenta de nuevo.',
): string => {
  const e = error as { message?: string | string[] } | null | undefined
  if (!e) return respaldo

  if (Array.isArray(e.message)) {
    const renglones = e.message.map(String).filter((r) => r.trim() !== '')
    return renglones.length > 0 ? renglones.join('. ') : respaldo
  }

  return typeof e.message === 'string' && e.message.trim() !== ''
    ? e.message
    : respaldo
}
